import { render, staticRenderFns } from "./choice.vue?vue&type=template&id=29f7885a&scoped=true&"
import script from "./choice.vue?vue&type=script&lang=js&"
export * from "./choice.vue?vue&type=script&lang=js&"
import style0 from "./choice.vue?vue&type=style&index=0&id=29f7885a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f7885a",
  null
  
)

export default component.exports